<p-dialog header="Re-order Task(s)" [(visible)]="displayReorderTasks" [modal]="true" [style]="{ width: '50em' }"
    [maximizable]="true" [baseZIndex]="10000" [draggable]="false" [resizable]="false" (onHide)="reOrderTasksHidden()">
    <div style="padding: 0.5em; display: flex; flex-direction: row">
        <button pButton type="button" class="p-button-secondary" style="margin-right: 1em" label="Reset"
            (click)="resetTaskSortOrder()" icon="pi pi-undo"></button>
        <p-message severity="info" text="Drag a row up or down to re-order.">
        </p-message>
    </div>

    <p-table stripedRows #TaskTable [scrollable]="true" [style]="{ 'max-width': '100%' }" [value]="timecardSequence"
        dataKey="Tasklongname" (onRowReorder)="onRowReorderHandler($event)">
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="17" style="text-align: center">
                    <div class="tabulator-placeholder">
                        <span> No Data Available </span>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="header">
            <tr class="tabulator-header">
                <th class="select-cell"></th>
                <th pResizableColumn class="tabulator-colgroup-header large-cell">
                    <div class="tabulator-col-content">Task</div>
                </th>
            </tr>
            <tr>
                <th class="tabulator-header-filter select-cell"></th>
                <th class="tabulator-header-filter large-cell"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-task let-ri="rowIndex">
            <tr class="tabulator-row" data-id="row-{{ task.Tasklongname }}" [pReorderableRow]="ri">
                <td class="p-datatable-cell select-cell">
                    <span class="pi pi-bars" pReorderableRowHandle title="click and drag to re-order"></span>
                </td>
                <td class="p-datatable-cell large-cell">
                    {{ task.Tasklongname }}
                </td>
            </tr>
        </ng-template>
    </p-table>

    <!-- <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="displayMaximizable=false" label="Yes" styleClass="p-button-text"></p-button>
    </ng-template> -->
</p-dialog>

<p-dialog [(visible)]="displayDocumentation" [modal]="true" [style]="{ width: '75vw', height: '85vh' }"
    [header]="timecardDocHeader" [maximizable]="true" [autoZIndex]="true" [draggable]="false" [resizable]="true"
    (onHide)="documentationHidden()">
    <!-- <ng-template #header>
        <span>{{ timecardDocHeader }}</span>
        <h4>
            {{
            moment(
            (userInfoSubject.asObservable() | async).UserEntryStartDate
            ).format('L')
            }}
            -
            {{
            moment(
            (userInfoSubject.asObservable() | async).UserEntryEndDate
            ).format('L')
            }}
        </h4>
    </ng-template> -->
    <p class="text-500 font-bold mt-0 mb-2 pt-0">
        {{
        moment(
        (userInfoSubject.asObservable() | async).UserEntryStartDate
        ).format('L')
        }}
        -
        {{
        moment(
        (userInfoSubject.asObservable() | async).UserEntryEndDate
        ).format('L')
        }}
    </p>

    <!-- timecard documentation -->
    <ef-time-card-documentation-feature [TimeCards]="timecardData"
        [EmployeeId]="EmployeeIdSubject.asObservable() | async" [AddDocumentation$]="AddDocumentation.asObservable()"
        [showDocumentation]="displayDocumentation" [action]="ActionsSubject | async" (Save)="onSave($event)">
    </ef-time-card-documentation-feature>
</p-dialog>

<div id="taskColumnHeader">
    <ng-template #header> </ng-template>
</div>

<div class="card pt-2" style="width: 100%; height: 100%">
    <div hidden>
        <button #weekZeroHeader id="weekZeroHeader" class="btn btn-link weekHeader" (click)="weeklyHeaderClicked(0)">
            {{ this.timeweek0 }}
        </button>
        <button #weekOneHeader id="weekOneHeader" class="btn btn-link weekHeader" (click)="weeklyHeaderClicked(1)">
            {{ this.timeweek1 }}
        </button>
        <button #weekTwoHeader id="weekTwoHeader" class="btn btn-link weekHeader" (click)="weeklyHeaderClicked(2)">
            {{ this.timeweek2 }}
        </button>
        <button #weekThreeHeader id="weekThreeHeader" class="btn btn-link weekHeader" (click)="weeklyHeaderClicked(3)">
            {{ this.timeweek3 }}
        </button>
        <button #weekFourHeader id="weekFourHeader" class="btn btn-link weekHeader" (click)="weeklyHeaderClicked(4)">
            {{ this.timeweek4 }}
        </button>
        <button #weekFiveHeader id="weekFiveHeader" class="btn btn-link weekHeader" (click)="weeklyHeaderClicked(5)">
            {{ this.timeweek5 }}
        </button>
        <button #weekSixHeader id="weekSixHeader" class="btn btn-link weekHeader" (click)="weeklyHeaderClicked(6)">
            {{ this.timeweek6 }}
        </button>
    </div>

    <div style="display: flex">
        <p-dialog [modal]="true" [draggable]="false" header="Required Comment for Change" [(visible)]="displayNotePopup"
            [maximizable]="false" [closable]="false" [closeOnEscape]="false">
            <p-messages [(value)]="msgs"></p-messages>
            <h3>Task: {{ changeCommentTask }}</h3>
            <h3>Date: {{ changeCommentDate }}</h3>
            <h4>Enter the reason for the change:</h4>
            <textarea class="ng-dirty ng-invalid" pInputTextarea [(ngModel)]="changeMessage"
                style="align-items: stretch; width: 100%; height: 50%" required></textarea>
            <ng-template #footer>
                <button type="button" pButton icon="pi pi-check" (click)="confirmBtnClicked()" label="Confirm"></button>
                <button type="button" pButton icon="pi pi-times" (click)="discardBtnClicked()" label="Discard"
                    class="p-button-secondary"></button>
            </ng-template>
        </p-dialog>
    </div>

    <div style="display: flex">
        <p-dialog [modal]="true" [draggable]="false" header="Required Comments for Time Changes"
            [(visible)]="displayBulkCommentPopup" [maximizable]="false" [closable]="false" [closeOnEscape]="false"
            [style]="{ width: '50rem', maxWidth: '95vw' }">
            <p-messages [(value)]="bulkCommentMsgs"></p-messages>
            <p-tabs [(value)]="bulkCommentActiveTabIndex" class="bulk-comment-tabs"
                [ngClass]="{ 'bulk-comment-tabs-scroll': shouldScrollBulkCommentTabs }">
                <p-tablist [ngStyle]="{
                        display: 'flex',
                        width: '100%',
                        'min-width': '100%',
                        'flex-wrap': 'nowrap',
                        'white-space': 'nowrap'
                    }">
                    <p-tab *ngFor="let entry of requiredCommentEntries; let i = index" [value]="i"
                        [ngStyle]="{
                            flex: shouldScrollBulkCommentTabs ? '0 0 auto' : '1 1 0',
                            'min-width': shouldScrollBulkCommentTabs ? '12rem' : '0'
                        }">
                        <span [title]="entry.date + ' | ' + entry.task"
                            [ngStyle]="{
                                display: 'inline-block',
                                'max-width': shouldScrollBulkCommentTabs ? '16rem' : '100%',
                                width: shouldScrollBulkCommentTabs ? null : '100%',
                                'white-space': 'nowrap',
                                overflow: 'hidden',
                                'text-overflow': 'ellipsis',
                                'vertical-align': 'bottom'
                            }">
                            {{ entry.date }} | {{ entry.task }}
                        </span>
                    </p-tab>
                </p-tablist>
                <p-tabpanels>
                    <p-tabpanel *ngFor="let entry of requiredCommentEntries; let i = index" [value]="i">
                        <h3>Task: {{ entry.task }}</h3>
                        <h3>Date: {{ entry.date }}</h3>                        
                        <h3>Change: {{ entry.changeSummary }}</h3>
                        <h4>Enter the reason for the change:</h4>
                        <textarea class="ng-dirty ng-invalid" pInputTextarea [(ngModel)]="entry.comment"
                            style="align-items: stretch; width: 100%; height: 8rem" required></textarea>
                    </p-tabpanel>
                </p-tabpanels>
            </p-tabs>
            <ng-template #footer>
                <button type="button" pButton icon="pi pi-copy" class="p-button-secondary"
                    (click)="applyActiveCommentToAllRequiredEntries()" label="Apply This Comment to All"></button>
                <button type="button" pButton icon="pi pi-check" (click)="confirmBulkCommentsAndSave()"
                    label="Confirm"></button>
                <button type="button" pButton  (click)="cancelBulkCommentDialog()"
                    label="Cancel" class="p-button-danger"></button>
            </ng-template>
        </p-dialog>
    </div>

    <div style="display: flex">
        <p-dialog header="Are you sure?" [(visible)]="displayDocumentationExceedingHoursWarningPopup"
            [maximizable]="false" [closable]="false" [closeOnEscape]="false">
            <h3>
                This change will cause your previously documented hours to
                exceed the time entry. Therefore, clicking confirm will make the
                change and remove previous documentation.
            </h3>
            <ng-template #footer>
                <button type="button" pButton icon="pi pi-check"
                    (click)="confirmBtnClickedForDocumentationExceedingHours()" label="Confirm"></button>
                <button type="button" pButton (click)="cancelBtnClickedForDocumentationExceedingHours()"
                    icon="pi pi-times" label="Cancel"></button>
            </ng-template>
        </p-dialog>
    </div>

    <div style="display: flex">
        <p-dialog header="Management Action" [(visible)]="showManagementActionErrorDialog" [maximizable]="false"
            [closable]="false" [closeOnEscape]="false" style="max-width: 15em;">
            <h4>Cannot perform a management action on time that has not been signed.</h4>
            <ng-template #footer>
                <button pButton type="button" class="p-button-primary p-button-text" label="OK"
                    (click)="showManagementActionErrorDialog = false"></button>
            </ng-template>
        </p-dialog>
    </div>

    <div style="display: flex">
        <p-dialog header="Management Action" [(visible)]="showManagementActionDialog" [maximizable]="false"
            [closable]="false" [closeOnEscape]="false">
            <div style="
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    flex-wrap: wrap;
                    justify-content: left;
                ">
                <label style="font-weight: bold; margin-right: 1em">Date:</label>
                <label>{{ this.selectedCellDate }}</label>
            </div>
            <div style="
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    flex-wrap: wrap;
                    justify-content: left;
                ">
                <label style="font-weight: bold; margin-right: 1em">Task:</label>
                <label>{{ this.selectedCellTask }}</label>
            </div>
            <div style="
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    flex-wrap: wrap;
                    justify-content: left;
                ">
                <label style="font-weight: bold; margin-right: 0.4em">Hours:</label>
                <label>{{ this.selectedCellValue }}</label>
            </div>
            <div style="
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    flex-wrap: wrap;
                    justify-content: left;
                ">
                <label style="font-weight: bold; margin-right: 0.2em">Status:</label>
                <label>{{ this.selectedCellStatus }}</label>
            </div>
            <!-- <h4>Date: {{ this.selectedCellDate }}</h4>
            <h4>Task: {{ this.selectedCellTask }}</h4>
            <h4>Hours: {{ this.selectedCellValue }}</h4> -->
            <ng-template #footer>
                <div *ngIf="isSupervisor == true">
                    <button pButton type="button" severity="primary" label="Approve"
                        (click)="managementAction('approve')"></button>
                    <button pButton type="button" severity="primary" class="ml-2 mr-2" label="Unapprove"
                        (click)="managementAction('unapprove')"></button>
                    <button pButton type="button" severity="primary" label="Disapprove"
                        (click)="managementAction('disapprove')"></button>
                    <button pButton type="button" class="p-button-danger" style="margin-left: 2em" label="Cancel"
                        (click)="showManagementActionDialog = false"></button>
                </div>
                <div *ngIf="isTaskManager == true">
                    <button pButton type="button" severity="primary" label="Validate"
                        (click)="managementAction('validate')"></button>
                    <button pButton type="button" severity="primary" class="ml-2 mr-2" label="Unvalidate"
                        (click)="managementAction('unvalidate')"></button>
                    <button pButton type="button" severity="primary" label="Disapprove"
                        (click)="managementAction('disapprove_validate')"></button>
                    <button pButton type="button" class="p-button-danger" style="margin-left: 2em" label="Cancel"
                        (click)="showManagementActionDialog = false"></button>
                </div>
            </ng-template>
        </p-dialog>
    </div>

    <div style="display: flex">
        <p-dialog header="Warning" [(visible)]="showNegativeHoursDialog" [maximizable]="false" [closable]="false"
            [closeOnEscape]="false">
            <h3>
                Time entry must be zero or greater, negative hours are not
                allowed.
            </h3>
            <ng-template #footer>
                <button type="button" pButton icon="pi pi-check" (click)="confirmBtnClickedNegativeHours()"
                    label="OK"></button>
            </ng-template>
        </p-dialog>
    </div>

    <div style="display: flex">
        <p-dialog header="Warning" [(visible)]="this.displayDeleteWarningPopup" [maximizable]="false" [closable]="false"
            [closeOnEscape]="false">
            <h3>To remove previously entered hours, change hours to 0.</h3>
            <ng-template #footer>
                <button type="button" pButton icon="pi pi-check" (click)="confirmBtnClickedForDelete()"
                    label="OK"></button>
            </ng-template>
        </p-dialog>
    </div>

    <div style="display: flex">
        <p-dialog header="Signature Policy" [(visible)]="displayPolicyPopup" [maximizable]="false" [closable]="false"
            [closeOnEscape]="false" [modal]="true">
            <h4>
                By signing this timesheet you are certifying that hours were
                incurred on the charge and day specified in accordance with
                company policies and procedures.
            </h4>

            <!-- <div
                style="
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    flex-wrap: wrap;
                    justify-content: left;
                "
            >
                <div style="margin-right: 1vw; margin-bottom: 2vh">
                    <p-checkbox
                        [(ngModel)]="timePolicyCbxChecked"
                        binary="true"
                    ></p-checkbox>
                </div>
                <div>
                    <h4>
                        To acknowledge the policy, check the box and click
                        Accept.
                    </h4>
                </div>
            </div> -->

            <div style="
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    flex-wrap: wrap;
                    justify-content: left;
                ">
                <div style="margin-right: 1vw; margin-bottom: 2vh">
                    <div style="display: flex; flex-direction: column">
                        <input pInputText type="password" [(ngModel)]="this.pswdForSig" (focus)="passwordInputFocused()"
                            autofocus />
                        <small *ngIf="this.showSignaturePolicyError" class="p-invalid">Invalid password</small>
                    </div>
                </div>

                <div>
                    <h4>
                        To acknowledge the policy, enter your password and click
                        Accept.
                    </h4>
                </div>
            </div>

            <!-- <h4 *ngIf="showSignaturePolicyError == true" style="color: red">
                Invalid password
            </h4> -->
            <!-- [disabled]="!timePolicyCbxChecked" -->
            <ng-template #footer>
                <button type="button" pButton icon="pi pi-check" (click)="confirmPolicyClicked()"
                    label="Accept"></button>
                <button type="button" pButton icon="pi pi-times" (click)="cancelBtnClicked()" label="Cancel"
                    class="p-button-secondary"></button>
            </ng-template>
        </p-dialog>
    </div>

    <div>
        <p-dialog appendTo="body" [contentStyle]="{
                'min-width': '20rem'
            }" header="Disapproval" [(visible)]="dialogVisible" #disapprovalDialog>
            <textarea pInputTextarea style="width: 100%" [(ngModel)]="this.mgrComment"
                placeholder="(Optional) - Enter a comment for disapproval."></textarea>
            <ng-template #footer>
                <button pButton label="Cancel" icon="pi pi-times" (click)="dialogVisible = false"
                    class="p-button-text p-button-danger"></button>
                <button pButton label="OK" icon="pi pi-check" class="p-button-text" (click)="mgrMessageEntered()"
                    class="p-button-text p-button-success"></button>
            </ng-template>
        </p-dialog>
    </div>

    <div *ngIf="isSupervisor === true || isTaskManager === true" class="outer">

        <!-- <a href="javascript:;" (click)="ed.toggle($event)">{{
            this.detailsLabel
        }}</a> -->
        <!-- <p-popover #ed>
            <div class="button-bar">
                Account Number: {{ this.timecardData[0].AccountNumber }}
            </div>
            <div class="button-bar" *ngIf="showAccrualsOnTimeCard == true">
                Accrual Info: {{ timecardAccrualInfo }}
            </div>
            <div class="button-bar">
                Current Entry Period Expected Hours:
                {{ this.timecardData[0].ExpectedHours }}
            </div>
        </p-popover> -->

        <div class="gridContainer timecard-main manager-workspace">
            <!-- Command bar: one period + primary action + overflow -->
            <div class="mgmt-command-bar" [formGroup]="mgmtPeriodFormGroup">
                <p-floatLabel variant="on" class="mgmt-period-field">
                    <p-datepicker
                        [monthNavigator]="true"
                        [yearNavigator]="true"
                        yearRange="2000:2030"
                        selectionMode="range"
                        [showIcon]="false"
                        formControlName="dateRange"
                        placeholder="Select period..."
                        (onSelect)="onDateForRangeSelected($event)">
                        <ng-template #header>Choose a Date Range</ng-template>
                    </p-datepicker>
                    <label class="management-period-header">{{ isTaskManager ? 'Validate Period' : 'Approval Period' }}</label>
                </p-floatLabel>

                <div class="flex items-center mgmt-command-option" *ngIf="isSupervisor">
                    <p-checkbox
                        class="ef-checkbox"
                        binary="true"
                        [ngModel]="showMyDRs"
                        [ngModelOptions]="{ standalone: true }"
                        (onChange)="showMyDRsChecked($event)"
                        title="Show My Direct Reports only">
                    </p-checkbox>
                    <label class="ml-2">My direct reports only</label>
                </div>

                <div class="flex items-center mgmt-command-option" *ngIf="isSupervisor">
                    <p-checkbox
                        class="ef-checkbox"
                        binary="true"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Include Disapproved Time"
                        (onChange)="onIncludeDisapprovedTime($event)">
                    </p-checkbox>
                    <label class="ml-2">Include disapproved</label>
                </div>

                <div class="mgmt-action-buttons" *ngIf="isSupervisor">
                    <button
                        pButton
                        type="button"
                        severity="primary"
                        label="Approve"
                        [disabled]="IsDisabled"
                        (click)="managementAction('approve')"></button>
                    <button
                        pButton
                        type="button"
                        severity="primary"
                        class="p-button-outlined"
                        label="Unapprove"
                        [disabled]="IsDisabled"
                        (click)="managementAction('unapprove')"></button>
                    <button
                        pButton
                        type="button"
                        severity="danger"
                        class="p-button-outlined"
                        label="Disapprove"
                        [disabled]="IsDisabled"
                        (click)="managementAction('disapprove')"></button>
                    <button
                        *ngIf="showTimeCardLockForSupervisors == true"
                        pButton
                        type="button"
                        severity="primary"
                        class="p-button-outlined"
                        icon="pi pi-lock"
                        [disabled]="IsDisabled"
                        pTooltip="Lock TimeCard"
                        tooltipPosition="bottom"
                        (click)="managementAction('lock')"></button>
                    <button
                        *ngIf="showTimeCardLockForSupervisors == true"
                        pButton
                        type="button"
                        severity="primary"
                        class="p-button-outlined"
                        icon="pi pi-unlock"
                        [disabled]="IsDisabled"
                        pTooltip="Unlock TimeCard"
                        tooltipPosition="bottom"
                        (click)="managementAction('unlock')"></button>
                </div>

                <div class="mgmt-action-buttons" *ngIf="isTaskManager">
                    <button
                        pButton
                        type="button"
                        severity="primary"
                        label="Validate"
                        [disabled]="IsDisabled"
                        (click)="managementAction('validate')"></button>
                    <button
                        pButton
                        type="button"
                        severity="primary"
                        class="p-button-outlined"
                        label="Unvalidate"
                        [disabled]="IsDisabled"
                        (click)="managementAction('unvalidate')"></button>
                    <button
                        pButton
                        type="button"
                        severity="danger"
                        class="p-button-outlined"
                        label="Disapprove"
                        [disabled]="IsDisabled"
                        (click)="managementAction('disapprove_validate')"></button>
                </div>

                <div class="mgmt-command-feedback" *ngIf="showManagementActionCompleteMsg">
                    <p-message
                        *ngIf="managementActionResp?.StatusCode == 1"
                        severity="success"
                        [text]="managementActionCompleteMsg">
                    </p-message>
                    <p-message
                        *ngIf="managementActionResp?.StatusCode == 3"
                        severity="warn"
                        [text]="managementActionCompleteMsg">
                    </p-message>
                </div>

                <p-message
                    class="mgmt-command-hint"
                    severity="info"
                    text="Double-click hours in the timecard for a single-cell action">
                </p-message>
            </div>

            <div class="timecard-layout">
                <div class="timecard-layout-left">
                    <div class="directReportGrid dr-queue">
                        <div class="dr-queue-header">
                            <span class="dr-queue-title">{{ (filteredDirectReports?.length || 0) }} - {{ directReportHeader }}</span>
                        </div>
                        <div class="direct-report-actions" *ngIf="directReportTimeStatusData?.length">
                            <span class="p-input-icon-left p-input-icon-right direct-report-search">
                                <i class="pi pi-search"></i>
                                <input
                                    pInputText
                                    type="text"
                                    placeholder="Search"
                                    [(ngModel)]="directReportSearchTerm"
                                    [ngModelOptions]="{ standalone: true }"
                                    aria-label="Search direct reports">
                                <i
                                    class="pi pi-times"
                                    *ngIf="directReportSearchTerm"
                                    (click)="directReportSearchTerm = ''"
                                    aria-label="Clear search"
                                    role="button"
                                    tabindex="0"
                                    (keydown.enter)="directReportSearchTerm = ''"
                                    (keydown.space)="directReportSearchTerm = ''"></i>
                            </span>
                            <p-floatLabel variant="on">
                                <p-select
                                    class="direct-report-sort"
                                    [options]="directReportSortOptions"
                                    [(ngModel)]="directReportSortBy"
                                    [ngModelOptions]="{ standalone: true }"
                                    optionLabel="label"
                                    optionValue="value"
                                    placeholder="Sort by"
                                    appendTo="body">
                                </p-select>
                                <label class="direct-report-sort-label">Sort by</label>
                            </p-floatLabel>
                            <button
                                type="button"
                                pButton
                                class="p-button-text p-button-sm"
                                (click)="toggleSelectAllDirectReports()">
                                {{ isAllDirectReportsSelected() ? 'Clear all' : 'Select all' }}
                            </button>
                        </div>
                        <div class="direct-report-panel">
                            <div class="direct-report-cards" *ngIf="filteredDirectReports?.length; else noDirectReports">
                                <div
                                    class="direct-report-card"
                                    *ngFor="let report of filteredDirectReports; trackBy: trackDirectReport"
                                    [class.is-selected]="report.EmployeeListID === selectedDirectReportId">
                                    <div
                                        class="direct-report-header"
                                        role="button"
                                        tabindex="0"
                                        (click)="onDirectReportSelect(report)"
                                        (keydown.enter)="onDirectReportSelect(report)"
                                        (keydown.space)="onDirectReportSelect(report)">
                                        <div class="direct-report-header-row">
                                            <div class="direct-report-select" (click)="$event.stopPropagation()">
                                                <p-checkbox
                                                    binary="true"
                                                    [ngModel]="isDirectReportSelected(report)"
                                                    (onChange)="onDirectReportSelectionChange(report, $event)">
                                                </p-checkbox>
                                            </div>
                                            <div class="direct-report-title">
                                                {{ report.UserName }}
                                            </div>
                                            <button
                                                type="button"
                                                class="p-button p-button-text p-button-plain p-button-sm"
                                                (click)="onDirectReportCardToggle(report); $event.stopPropagation()"
                                                aria-label="Toggle direct report details">
                                                <i class="pi" [ngClass]="isDirectReportExpanded(report) ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
                                            </button>
                                        </div>
                                        <div class="direct-report-status compact">
                                            <div class="status-row" *ngIf="requireTimeSubmit" [ngStyle]="getStatusStyle('Saved')" [class.status-selected]="isStatusSelected('Saved')">
                                                <span class="status-label" [ngStyle]="getStatusLabelStyle('Saved')">Saved</span>
                                                <span class="status-hours" [ngStyle]="getStatusHoursStyle('Saved')">{{ formatStatusValue(report.Saved) }}</span>
                                            </div>
                                            <div class="status-row" [ngStyle]="getStatusStyle('Signed')" [class.status-selected]="isStatusSelected('Signed')">
                                                <span class="status-label" [ngStyle]="getStatusLabelStyle('Signed')">Signed</span>
                                                <span class="status-hours" [ngStyle]="getStatusHoursStyle('Signed')">{{ formatStatusValue(report.Signed) }}</span>
                                            </div>
                                            <div class="status-row" *ngIf="shouldShowValidated()" [ngStyle]="getStatusStyle('Validated')" [class.status-selected]="isStatusSelected('Validated')">
                                                <span class="status-label" [ngStyle]="getStatusLabelStyle('Validated')">Validated</span>
                                                <span class="status-hours" [ngStyle]="getStatusHoursStyle('Validated')">{{ formatStatusValue(report.Validated) }}</span>
                                            </div>
                                            <div class="status-row" [ngStyle]="getStatusStyle('Approved')" [class.status-selected]="isStatusSelected('Approved')">
                                                <span class="status-label" [ngStyle]="getStatusLabelStyle('Approved')">Approved</span>
                                                <span class="status-hours" [ngStyle]="getStatusHoursStyle('Approved')">{{ formatStatusValue(report.Approved) }}</span>
                                            </div>
                                            <div class="status-row" [ngStyle]="getStatusStyle('Disapproved')" [class.status-selected]="isStatusSelected('Disapproved')">
                                                <span class="status-label" [ngStyle]="getStatusLabelStyle('Disapproved')">Disapproved</span>
                                                <span class="status-hours" [ngStyle]="getStatusHoursStyle('Disapproved')">{{ formatStatusValue(report.Disapproved) }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="direct-report-body" *ngIf="isDirectReportExpanded(report)">
                                        <div class="direct-report-details">
                                            <div class="detail-row">
                                                <span class="detail-label">Current Entry Period</span>
                                                <span>{{ getCurrentEntryPeriod(report) }}</span>
                                            </div>
                                            <div class="detail-row">
                                                <span class="detail-label">Impacted Range</span>
                                                <span>{{ formatDirectReportDate(report.ImpactedStart) }} - {{ formatDirectReportDate(report.ImpactedEnd) }}</span>
                                            </div>
                                            <div class="detail-row">
                                                <span class="detail-label">Documented</span>
                                                <span>{{ formatStatusValue(report.Documented) }}</span>
                                            </div>
                                            <div class="detail-row">
                                                <span class="detail-label">Leave Accrual</span>
                                                <span>{{ report.LeaveAccrualInfo || '—' }}</span>
                                            </div>
                                            <div class="detail-row">
                                                <span class="detail-label">Manually Locked</span>
                                                <span>{{ formatDirectReportDate(report.LockedDate) }}</span>
                                            </div>
                                            <div class="detail-row" *ngIf="report.AccountNumber">
                                                <span class="detail-label">Account Number</span>
                                                <span>{{ report.AccountNumber }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <ng-template #noDirectReports>
                                <div class="direct-report-empty">No direct reports available.</div>
                            </ng-template>
                        </div>
                    </div>
                </div>

                <div class="timecard-layout-right">
                    <div class="timeCardGrid">
                        <div *ngIf="displayDocWarning == true" class="flex justify-content-center mt-1">
                            <p-message severity="warn"
                                text="You have documented hours that are greater than time entered.">
                            </p-message>
                        </div>

                        <div class="timecard-tabulator manager-timecard-stage">
                            <p-panel
                                #weeklySummaryPanel
                                class="weekly-summary-panel mb-2"
                                [toggleable]="true"
                                [collapsed]="weeklySummaryCollapsed"
                                (onAfterToggle)="onWeeklySummaryToggle($event)">
                                <ng-template pTemplate="header">
                                    <div class="weekly-summary-header" (click)="weeklySummaryPanel.toggle($event)" style="cursor: pointer">
                                        <span class="weekly-summary-title">
                                            Weekly Summary
                                            <span class="text-color-secondary" *ngIf="mgmtDateRangeStart && mgmtDateRangeEnd">
                                                | {{ mgmtDateRangeStart }} - {{ mgmtDateRangeEnd }}
                                            </span>
                                        </span>
                                        <div class="weekly-summary-metrics">
                                            <span class="summary-metric">
                                                # of tasks {{ weeklySummaryRowCount }}
                                            </span>
                                            <span class="summary-metric">
                                                # of weeks {{ weeklySummaryWeekCount }}
                                            </span>
                                            <span class="summary-metric" *ngIf="getWeeklySummaryValue('PeriodTotal') !== null">
                                                Total Hours {{ getWeeklySummaryValue('PeriodTotal') }}
                                            </span>
                                        </div>
                                    </div>
                                </ng-template>
                                <div class="weekly-summary-body">
                                    <div style="display: flex" class="w-full">
                                        <div class="w-full" id="tabWeeklySummary"></div>
                                    </div>
                                </div>
                            </p-panel>

                            <div class="week-navigation-header mb-2">
                                <div class="flex justify-content-between align-items-center flex-wrap gap-2">
                                    <div class="flex align-items-center gap-2">
                                        <button pButton severity="primary" icon="pi pi-angle-double-left"
                                            (click)="goToNextOrPreviousWeek('prev')" title="Previous Week"></button>
                                        <button pButton severity="primary" icon="pi pi-angle-double-right"
                                            (click)="goToNextOrPreviousWeek('next')" title="Next Week"></button>
                                    </div>
                                    <div class="text-center flex-grow-1">
                                        <h3 class="m-0 text-color">{{ selectedDirectReport?.UserName || 'Timecard' }}</h3>
                                        <small class="text-color-secondary" *ngIf="sortedByTask.length > 0">
                                            {{ sortedByTask[0].Day0.WorkDateHdr }} - {{ lastDayWorkDateHdr }}
                                        </small>
                                    </div>
                                    <div class="flex align-items-center gap-2 justify-content-end">
                                        <p-message *ngIf="hasUnsavedChanges" severity="warn" [text]="'You have unsaved changes in the timecard.'"></p-message>
                                    </div>
                                </div>
                            </div>

                            <div id="tabTimeCard"></div>

                            <div class="timecard-footer mt-2" *ngIf="sortedByTask.length > 0">
                                <div class="flex justify-content-between align-items-center text-sm text-color-secondary flex-wrap gap-2">
                                    <div class="flex align-items-center gap-2 flex-grow-1 flex-wrap">
                                        <i class="pi pi-info-circle mr-1 ml-1" *ngIf="!hasUnsavedChanges"></i>
                                        <span *ngIf="!hasUnsavedChanges">Review hours, then use the action buttons above (or double-click a cell).</span>
                                    </div>
                                </div>
                            </div>

                            <p-panel class="weekly-summary-panel documentation-panel mt-2" [toggleable]="true" [collapsed]="true">
                                <ng-template pTemplate="header">
                                    <div class="weekly-summary-header">
                                        <span>Documentation</span>
                                        <div class="weekly-summary-metrics">
                                            <span class="summary-metric">
                                                # of tasks {{ documentationTaskCount }}
                                            </span>
                                            <span class="summary-metric">
                                                Hours {{ formatMetricValue(documentationHoursTotal) }}
                                            </span>
                                            <span class="summary-metric">
                                                Doc hours {{ formatMetricValue(documentationDocumentedHoursTotal) }}
                                            </span>
                                        </div>
                                    </div>
                                </ng-template>
                                <div class="weekly-summary-body">
                                    <ef-time-card-documentation-feature [TimeCards]="timecardData"
                                        [EmployeeId]="EmployeeIdSubject.asObservable() | async"
                                        [AddDocumentation$]="AddDocumentation.asObservable()" [action]="ActionsSubject | async"
                                        (Save)="onSave($event)">
                                    </ef-time-card-documentation-feature>
                                </div>
                            </p-panel>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="timecard-bottom">
            <div class="legend">
                <div class="flex items-center">
                    <div>
                        <label style="font-size: 12px" class="mr-2">Status Colors: </label>
                    </div>
                    <button pButton *ngFor="let item of userWebColors" [style.color]="item.Forecolor_Hex"
                        [style.backgroundColor]="item.Backcolor_hex" style="height: 1.5em; font-size: 12px; border: none; border-radius: 0px;">
                        {{ item.Status }}
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="isUser == true || isSuperUser == true">
        <!-- <button style="font-size: 16px; padding: 0; height: 18px; margin-bottom: 5px; border-bottom: 1px solid #429AE8;"
            pButton class="p-button-text" [label]="this.detailsLabel" (click)="ed.toggle($event)"
            *ngIf="this.isUser == true"></button> -->
        <!-- <a *ngIf="this.isUser == true" href="javascript:;" (click)="ed.toggle($event)">{{ this.detailsLabel }}</a> -->
        <!-- <button
            style="font-size: 16px; font-size: 16px; padding: 0; height: 18px; margin-bottom: 5px; border-bottom: 1px solid #429AE8;"
            pButton class="p-button-text" [label]="this.detailsLabel" (click)="ed.toggle($event)"
            *ngIf="this.isSuperUser == true && this.isDRSelected == true"></button> -->
        <!-- <a
            *ngIf="this.isSuperUser == true && this.isDRSelected == true"
            href="javascript:;"
            (click)="ed.toggle($event)"
            >{{ this.detailsLabel }}</a
        > -->
        <!-- <p-popover #ed>
            <div class="button-bar">
                Account Number: {{ this.timecardData[0].AccountNumber }}
            </div>
            <div class="button-bar" *ngIf="showAccrualsOnTimeCard == true">
                Accrual Info: {{ timecardAccrualInfo }}
            </div>
            <div class="button-bar" *ngIf="this.isUser">
                Current Entry Period:
                {{ this.userEntryStartDate }} - {{ this.userEntryEndDate }}
            </div>
            <div class="button-bar">
                Current Entry Period Expected Hours:
                {{ this.timecardData[0].ExpectedHours }}
            </div>
        </p-popover> -->

        <div class="timecard" style="margin-top: 0.5em">
            <p-toolbar>
                <div *ngIf="isSuperUser == true" class="mr-3">
                    <form [formGroup]="filterFormGroup" #filterForm="ngForm" id="filterForm">
                        <div *ngIf="activeDirectReports as items">
                            <p-floatLabel variant="on">
                                <p-dropdown #pmg [options]="items" styleClass="w-16rem" appendTo="body"
                                    [autoDisplayFirst]="false" formControlName="directReports" optionLabel="EmployeeName"
                                    dataKey="EmployeeListID" [filter]="true"></p-dropdown>
                                <label for="float-dd">Direct Reports</label>
                            </p-floatLabel>
                        </div>
                    </form>
                </div>
                <button *ngIf="
                        (isSuperUser === true &&
                            filterFormGroup.controls['directReports'].value) ||
                        isUser === true
                    " pButton type="button" severity="primary" class="mr-2" label="Document Time" icon="pi pi-book"
                    [disabled]="stagedEditsBlockSignAndDocument"
                    [attr.title]="stagedEditsBlockSignAndDocument ? 'Save your timecard changes before opening documentation.' : null"
                    (click)="documentTimeToolbarClicked()"></button>
                <button *ngIf="isUser == true" pButton type="button" icon="pi pi-sort-alt" severity="primary"
                    label="Re-order Task(s)" (click)="getTimecardSequence()"></button>
                <div *ngIf="this.displayDocWarning == true" style="
                        display: flex;
                        justify-content: center;
                        margin-top: 0.5vh;
                    ">
                    <p-message severity="warn" text="You have documented hours that are greater than time entered.">
                    </p-message>
                </div>
                <!-- <span *ngIf="this.isUser == true" style="align-self: center; margin-left: 30%" class="font-bold"> Current Entry Period: {{ this.userEntryStartDate }} - {{ this.userEntryEndDate }}</span> -->
            </p-toolbar>
            <p-accordion (onClose)="onTabClose($event)">
                <p-accordionTab [disabled]="true" [selected]="true">
                    <ng-template #header>
                        <label>{{this.timecardHeader}}</label>
                        <label *ngIf="this.isUser == true" class="flex justify-content-center">{{
                            this.userEntryStartDate }} - {{this.userEntryEndDate }}</label>
                    </ng-template>
                    <!-- <div style="display: flex; justify-content: center">

                        <div *ngIf="
                                this.isSupervisor == true ||
                                this.isTaskManager == true
                            " class="button-bar button-bar-start button-bar-padless" style="width: 61%"></div>
                        <div style="
                                display: flex;
                                justify-content: right;
                                flex-wrap: nowrap;
                            ">
                            <label style="
                                    color: #363a41;
                                    margin-bottom: 0px;
                                    font-weight: lighter;
                                ">
                                {{ this.dblClickDirections }}
                            </label>
                        </div>
                    </div> -->

                    <div style="display: flex; justify-content: center">
                        <!-- <div *ngIf="this.tabTimeCard" style="align-items: stretch">
                            <button id="prevButton" class="ui-corner-left" style="float: left; height: 100%" pButton
                                icon="pi pi-angle-double-left" (click)="goToNextOrPreviousWeek('prev')"></button>
                        </div> -->

                        <div class="timecard-tabulator" style="width: 90vw; max-width: 100%">
                                <p-panel
                                #weeklySummaryPanel
                                class="weekly-summary-panel"
                                [toggleable]="true"
                                [collapsed]="weeklySummaryCollapsed"
                                (onAfterToggle)="onWeeklySummaryToggle($event)"
                            >
                                <ng-template pTemplate="header">
                                    <div class="weekly-summary-header" (click)="weeklySummaryPanel.toggle($event)" style="cursor: pointer">
                                        <span class="weekly-summary-title">
                                            Weekly Summary
                                            <span class="text-color-secondary" *ngIf="userEntryStartDate && userEntryEndDate">
                                                | {{ userEntryStartDate }} - {{ userEntryEndDate }}
                                            </span>
                                        </span>
                                        <div class="weekly-summary-metrics">
                                            <span class="summary-metric">
                                                # of tasks {{ weeklySummaryRowCount }}
                                            </span>
                                            <span class="summary-metric">
                                                # of weeks {{ weeklySummaryWeekCount }}
                                            </span>
                                            <span class="summary-metric" *ngIf="getWeeklySummaryValue('PeriodTotal') !== null">
                                                Total Hours {{ getWeeklySummaryValue('PeriodTotal') }}
                                            </span>
                                        </div>
                                    </div>
                                </ng-template>
                                <div class="weekly-summary-body">
                                    <div style="display: flex" class="w-full">
                                        <div class="w-full" id="tabWeeklySummary"></div>
                                    </div>
                                </div>
                            </p-panel>
                            <!-- Toolbar above table: Prev/Next left, Save/Sign right -->
                            <div class="week-navigation-header mb-2">
                                <div class="flex justify-content-between align-items-center flex-wrap gap-2">
                                    <div class="flex align-items-center gap-2">
                                        <button pButton class="ml-1" severity="primary" icon="pi pi-angle-double-left"
                                            (click)="goToNextOrPreviousWeek('prev')" title="Previous Week"></button>
                                        <button pButton class="mr-1" severity="primary" icon="pi pi-angle-double-right"
                                            (click)="goToNextOrPreviousWeek('next')" title="Next Week"></button>
                                    </div>
                                    <div class="text-center flex-grow-1">
                                        <h3 class="m-0 text-color">Timecard</h3>
                                        <small class="text-color-secondary" *ngIf="sortedByTask.length > 0">
                                            {{ sortedByTask[0].Day0.WorkDateHdr }} - {{ lastDayWorkDateHdr }}
                                        </small>
                                    </div>
                                    <div class="flex align-items-center gap-2">
                                        <p-message *ngIf="hasUnsavedChanges" severity="warn" [text]="'You have unsaved changes in the timecard.'"></p-message>
                                        <button *ngIf="!saveOnCellBlur" pButton type="button" label="Save" icon="pi pi-save" class="p-button-primary"
                                            [disabled]="!hasUnsavedChanges" (click)="saveAllPending()"></button>
                                        <button *ngIf="(isUser == true || isSuperUser == true)" [ngClass]="{'hidden': !requireTimeSubmit}" pButton severity="primary"
                                            [disabled]="stagedEditsBlockSignAndDocument"
                                            [attr.title]="stagedEditsBlockSignAndDocument ? 'Save your timecard changes before signing the week.' : null"
                                            (click)="requireTimeSubmitWeekClicked()" label="Sign Week"></button>
                                        <button *ngIf="(isUser == true || isSuperUser == true)" pButton severity="primary"
                                            [disabled]="stagedEditsBlockSignAndDocument"
                                            [attr.title]="stagedEditsBlockSignAndDocument ? 'Save your timecard changes before signing the period.' : null"
                                            (click)="requireTimeSubmitPeriodClicked()" [ngClass]="{'hidden': !requireTimeSubmit}" label="Sign Period"></button>
                                    </div>
                                </div>
                            </div>
                            <div id="tabTimeCard"></div>
                            <!-- Toolbar below table: same layout -->
                            <div class="timecard-footer mt-2" *ngIf="sortedByTask.length > 0">
                                <div class="flex justify-content-between align-items-center text-sm text-color-secondary flex-wrap gap-2">
                                    <div class="flex align-items-center gap-2 flex-grow-1 flex-wrap">
                                        <i class="pi pi-info-circle mr-1 ml-1" *ngIf="!hasUnsavedChanges"></i>
                                        <span *ngIf="!hasUnsavedChanges && requireTimeSubmit">Time is saved when you click Save. Digital signature only applied after signing the week or period.</span>
                                        <span *ngIf="!hasUnsavedChanges && !requireTimeSubmit">Digital signature applied when timecard is saved.</span>
                                        <span *ngIf="dblClickDirections" class="ml-2">{{ this.dblClickDirections }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- <div *ngIf="this.tabTimeCard" style="align-items: stretch">
                            <button id="nextButton" class="ui-corner-right" style="float: right; height: 100%" pButton
                                icon="pi pi-angle-double-right" (click)="goToNextOrPreviousWeek('next')"></button>
                        </div> -->
                    </div>
                    <!-- <div class="flex justify-content-center" [hidden]="this.requireTimeSubmit">
                        <label style="color: #363a41;">
                            Digital signature applied as timecard is modified.
                        </label>
                    </div> -->
                </p-accordionTab>
            </p-accordion>
        </div>

        <div class="legend" style="margin-top: 5px; width: 100%">
            <div class="flex items-center">
                <div>
                    <label style="font-size: 12px" class="mr-2">Status Colors: </label>
                </div>
                <button pButton *ngFor="let item of userWebColors" [style.color]="item.Forecolor_Hex"
                    [style.backgroundColor]="item.Backcolor_hex" style="height: 1.5em; font-size: 12px; border: none; border-radius: 0px;">
                    {{ item.Status }}
                </button>
            </div>
        </div>
    </div>
</div>
